<template>
  <body>
    <Navbar />
    <router-view />
    <Footer />
  </body>
</template>

<script>
import Footer from '../../layouts/components/Footer.vue'
import Navbar from '../../layouts/components/Navbar.vue'

export default {
  name: 'Home',
  components: {
    Footer, Navbar
  },
  props: {
    msg: String
  }
}
</script>

<style>
/* Cache la bannière Google Translate */
.goog-te-banner-frame.skiptranslate {
  display: none !important;
}

/* Supprime la marge ajoutée par Google Translate au body */
body {
  top: 0px !important;
}

/* Cache la boîte autour du contenu traduit */
.skiptranslate {
  display: none !important;
}

</style>